import styled, { css } from "styled-components"

type ButtonVariant = "primary" | "outline"

/**
 * `textOnAccent` rather than `textPrimary`: the amber fill does not change with
 * the mode, so the label on it must not either — dark mode's near-white
 * `textPrimary` on amber is 1.9:1.
 */
const primary = css`
  color: ${({ theme }) => theme.color.textOnAccent};
  background-color: ${({ theme }) => theme.color.accent};
  border-color: ${({ theme }) => theme.color.accent};

  &:hover:not(:disabled) {
    background-color: ${({ theme }) => theme.color.accentHover};
    border-color: ${({ theme }) => theme.color.accentHover};
  }
`

const outline = css`
  color: ${({ theme }) => theme.color.textPrimary};
  background-color: transparent;
  border-color: ${({ theme }) => theme.color.borderStrong};

  &:hover:not(:disabled) {
    background-color: ${({ theme }) => theme.color.surfaceSubtle};
  }
`

export const Button = styled.button<{ $variant?: ButtonVariant }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: ${({ theme }) => theme.spacing.xs};
  padding: ${({ theme }) => `${theme.spacing.xs} ${theme.spacing.md}`};
  border: 1px solid transparent;
  border-radius: ${({ theme }) => theme.radius.pill};
  font-size: ${({ theme }) => theme.fontSize.sm};
  font-weight: ${({ theme }) => theme.fontWeight.medium};
  cursor: pointer;
  transition: background-color 120ms ease-in-out;

  ${({ $variant }) => ($variant === "outline" ? outline : primary)}

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }
`
